module.exports = __webpack_public_path__ + "img/magento-support-security_medium.df01bfe1.webp";